/* eslint-disable jira/filename-case */
export const KNOWN_COLUMN_TYPES = {
	ASSIGNEE: 'assignee',
	CHECKBOX: '__issuetable_internal_checkbox',
	CHECKBOX_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
	DESCRIPTION: 'description',
	ENVIRONMENT: 'environment',
	EXPAND_BUTTON: '__issuetable_internal_expand_button',
	ISSUE_KEY: 'issuekey',
	ISSUE_OPERATIONS: '__issuetable_internal_meatball',
	STATUS: 'status',
	SUMMARY: 'summary',
	ISSUE_TYPE: 'issuetype',
	RESOLUTION: 'resolution',
	PARENT: 'parent',
	LABELS: 'labels',
	COMPONENTS: 'components',
	FIX_VERSIONS: 'fixVersions',
	STATUS_CATEGORY: 'statusCategory',
	PROJECT: 'project',
	READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
	SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
	TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
	EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
	CREATED: 'created',
	RESOLUTION_DATE: 'resolutiondate',
	TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
	UPDATED: 'updated',
	DUE_DATE: 'duedate',
	REPORTER: 'reporter',
	CREATOR: 'creator',
	PRIORITY: 'priority',
	AFFECTS_VERSIONS: 'versions',
	REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
	NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
	STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points',
	USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
	CUSTOM_LABELS: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
	TIMELINE: 'timeline',
	DATE_TIME: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
	URL: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
	SINGLE_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
	MULTI_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
	MULTI_USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
	MERGED_COLUMN: '__issuetable_internal_merged_column',
	TEAM: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
	ORIGINAL_ESTIMATE: 'timeoriginalestimate',
	GOALS: 'com.atlassian.jira.plugin.system.customfieldtypes:goals',
	CASCADING_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
	CONFLUENCE_PAGES: 'confluenceRemoteIssueLinks',
	PEOPLE: 'com.atlassian.jira.plugin.system.customfieldtypes:people',
	DATE_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker',
	ATLAS_PROJECT: 'com.atlassian.jira.plugin.system.customfieldtypes:atlas-project',
	RELATIONSHIP: 'issueLinkRelationshipType',
	AGENT_SESSIONS: 'com.atlassian.jira.plugin.system.customfieldtypes:agent-sessions',
} as const;

export const COLUMN_ID_MEATBALL_MENU = '__issuetable_internal_meatball';
export const COLUMN_ID_EXPAND_BUTTON = '__issuetable_internal_expand_button';
export const COLUMN_ID_CHECKBOX = '__issuetable_internal_checkbox';
export const COLUMN_ID_MERGED_COLUMN = '__issuetable_internal_merged_column';

export const MERGED_COLUMN_TYPES: ('issuekey' | 'summary' | 'issuetype')[] = [
	KNOWN_COLUMN_TYPES.ISSUE_TYPE,
	KNOWN_COLUMN_TYPES.ISSUE_KEY,
	KNOWN_COLUMN_TYPES.SUMMARY,
];
export const MERGED_COLUMN_IDS: string[] = ['issuetype', 'issuekey', 'summary'];
export const MERGED_COLUMN_DEFAULT_WIDTH = 64; // 24 * 2 (two icons) + 8*2 (horizontal padding)

export const NIN_PROJECT_OPERATION_SCOPE = 'NIN_PROJECT' as const;
export const NIN_GLOBAL_OPERATION_SCOPE = 'NIN_GLOBAL' as const;
